"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHeadline = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledHeadline = _styledComponents.default.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 900;\n  line-height: 22px;\n  font-family: 'univers-black', sans-serif;\n  font-size: 20px;\n  ", "\n\n  @media (min-width: 768px) {\n    line-height: ", ";\n    font-size: ", ";\n  }\n\n  @media (min-width: 1200px) {\n    line-height: ", ";\n    font-size: ", ";\n  }\n"])), (0, _layout.setContainer)({
  size: 'sm'
}), function (_ref) {
  var bold = _ref.bold;
  return bold ? '35px' : '26px';
}, function (_ref2) {
  var bold = _ref2.bold;
  return bold ? '32px' : '24px';
}, function (_ref3) {
  var bold = _ref3.bold;
  return bold ? '53px' : '35px';
}, function (_ref4) {
  var bold = _ref4.bold;
  return bold ? '48px' : '32px';
});

exports.StyledHeadline = StyledHeadline;